import { Reference } from 'types/reference';

export const resolveReferenceTarget = (reference: Reference) => {
  switch (reference.type) {
    case 'link':
      return reference.link || reference.target;
    case 'page-folder':
      return reference.pageFolder._url;
  }
};

export const resolveReferenceProps = (reference: Reference) => {
  let returnValue = {};
  if (reference.openInNewWindow) {
    returnValue = {
      ...returnValue,
      target: '_blank',
      rel: 'noopener',
    };
  }
  if (reference.type === 'link' && reference.scroll === false) {
    returnValue = {
      ...returnValue,
      scroll: false,
    };
  }

  return returnValue;
};
